import styled from "styled-components";
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const Overlay = styled.div`
  --modal-top-offset: clamp(40px, 10vh, 96px);
  visibility: ${({ open }) => (open ? "visible" : "hidden")};
  opacity: ${({ open }) => (open ? "1" : "0")};
  display: grid;
  align-items: start;
  justify-items: center;
  overflow-y: auto;
  padding: var(--modal-top-offset) 24px 24px;
  transition: opacity 180ms ease,
    visibility 0s linear ${({ open }) => (open ? "0s" : "180ms")};
  position: fixed;
  inset: 0;
  background: rgba(23, 25, 20, 0.7);
  backdrop-filter: blur(2px);
  z-index: 9999;
`;

const ModalElement = styled.div`
  width: min(400px, 100%);
  max-height: calc(100vh - var(--modal-top-offset) - 24px);
  max-height: calc(100dvh - var(--modal-top-offset) - 24px);
  box-sizing: border-box;
  overflow-y: auto;
  margin: 0;
  padding: 24px;
  background: #fff;
  border: 1px solid var(--app-line);
  border-radius: 12px;
  box-shadow: 0 24px 70px rgba(23, 25, 20, 0.24);
`;

export function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}

function Modal({ children, open, onClose, ...rest }) {
  const ref = useRef();

  useOnClickOutside(ref, () => open && onClose && onClose());

  return createPortal(
    <Overlay open={open}>
      <ModalElement open={open} {...rest} ref={ref}>
        {children}
      </ModalElement>
    </Overlay>,
    document.body
  );
}

export default Modal;
